export const CONSTANTE_VERSION_PRIMERA_POLIZAS = 'V1';

export const CONSTANTE_INDDIGITALFIRM = 'I';

export const CONSTANTE_PARAM_FIRMA_DIGITAL = 'paramIndFirDig';

export const CONSTANTE_VERSION_SUBROGACION_LEASING = 'V4';

export const CONSTANTE_VERSION_PRESTAMO_REESTRUCTURACIONES = 'V8';
